export default "__VITE_ASSET__DhvpLFqy__"